export class ActionStore {
    constructor(botStore) {
        this.botStore = botStore;
    }

    execute(method, args = {}) {
        this.botStore.socket.emit('message', { channel: 'action:execute', method, ...args });
    }
}



// WEBPACK FOOTER //
// ./src/stores/ActionsStore.js